import { FormEvent, useState } from "react";
import { useLogin } from "../../../config/connection/auth";
import LoginForm from "../components/LoginForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../config";
import { WarnTypes, validateEmail, validatePassword } from "../../../utils/helpers";
import { useNotificationStore } from "../../../stores/notifications";

interface IWarn {
  message: string;
  id: WarnTypes;
}

export const Login = () => {
  const login = useLogin();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { addNotification } = useNotificationStore();
  // A página que a pessoa tentou abrir antes de logar. Só caminhos de dentro do app.
  const voltar = params.get('voltar');
  const destino = voltar && voltar.startsWith('/app/') && !voltar.startsWith('//') ? voltar : DASHBOARD_ROUTE;

  const [warns, setWarns] = useState<IWarn[]>([]);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    
    const target = event.target as typeof event.target & {
      email: { value: string };
      password: { value: string };
    };

    const email = target.email.value;
    const password = target.password.value;

    const isEmailValid = validateEmail(email);
    const isPasswordValid = validatePassword(password);
    const validationArray = [isEmailValid, isPasswordValid];
    const validator = validationArray.filter(e => e.status === false);

    setWarns(validator);
    if(validator.length !== 0) return;

    setLoading(true);
    const data = await login.mutateAsync({ email, password });
    setLoading(false);

    if(typeof(data) === "string") {
      // `data` como string significa recusa do servidor - a mensagem do erro. O caso mais
      // comum e "confirme seu email": e uma instrucao, nao um alarme, e a pessoa precisa dela
      // na tela enquanto vai ate a caixa de entrada. Por isso fica fixa no formulario, alem da
      // notificacao, em vez de so passar num popup que some sozinho.
      setWarns([{ message: data, id: WarnTypes.SERVER }]);
      addNotification({ type: "warning", title: data });
    } else if(data) {
      navigate(destino);
    }
  }

  return <LoginForm onSubmit={onSubmit} warns={warns} loading={loading} />;
};